const a=(t,i,d)=>{d(t.util.updateQueryData("init",void 0,e=>{e.adverts=e.adverts.filter(r=>r.id!==i)}))};export{a as apiAdvertFavoriteRemoveAdvert};
